import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import { getGermanStatesList } from '../../../services/accreditation-forms-service';
// import { getCountryStates } from '../../../services/accreditation-forms-service';
import store from '../../../store';

const useInputStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: theme.custom.inputs.maxWidth,
    marginBottom: theme.spacing(5),
  },
}));

const InputSelectCountryState = ({ hint, required, label, ...props }) => {
  const [stateList, setStateList] = useState([]);
  const { tenantId, token } = store.getState().formSession;

  useEffect(() => {
    getCountryStatesList();
  }, []);

  const getCountryStatesList = async () => {
    const contryStates = await getGermanStatesList(tenantId, token); // await getCountryStates();
    if (contryStates) {
      setStateList(contryStates);
    }
  };
  const classes = useInputStyles();
  const optionElements = stateList?.map((state) => (
    <MenuItem key={state} value={state}>
      {state}
    </MenuItem>
  ));
  return (
    <TextField
      {...props}
      size="small"
      label={label}
      required={required}
      helperText={hint}
      select
      variant="outlined"
      className={classes.root}
      color="primary"
    >
      {optionElements}
    </TextField>
  );
};

InputSelectCountryState.propTypes = {
  required: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.string,
    }),
  ).isRequired,
};

InputSelectCountryState.defaultProps = {
  hint: null,
};

export default InputSelectCountryState;
